export const environment = {
  production: false,
  API_URL: 'https://multiplan-api-dev.azure-api.net/canallojista/dev/',
  API_KEY: '548fcaef162c4be8a5ba5abcb6cbcd50',
  NOTIF_URI: 'https://multiplan-api-dev.azure-api.net/notificacao-canallojista/dev/',
  STORAGE_KEY: 'storagenot_multiplan_dev_02',
  STORAGE_NOTIFICACAO: 'storagenot_multiplan_dev_02',
  INSIGHTS: 'e4c719dd-fb94-4469-86a0-252c1784c694',
  AMBIENTE: 'd',
  VERSAO: '1.0.0',
  CHAT_URL: 'https://appwebchatvideolibsmb.z21.web.core.windows.net/index.html',
  PUSHER_KEY: 'e55e310dd7869a40f259',
  PUSHER_AMBIENTE: 'D',
  PUSHER_CHANNEL: 'ambiente',
  PUSHER_CLUSTER: 'sa1',
  MULTIPLAN_IMAGE_HOME: [
    'https://multiplan-central-lojista.s3.amazonaws.com/home.png',
    'https://multiplan-central-lojista.s3.amazonaws.com/home2.png',
    'https://multiplan-central-lojista.s3.amazonaws.com/home3.png'
  ],
  MULTIPLAN_URL_HOME: [
    'https://multishopping.page.link/veCs',
    'https://multishopping.page.link/veCs',
    'https://multishopping.page.link/veCs'
  ],
  MULTIPLAN_IMAGE_HOME_BANNER: '/assets/img/homeatt.png',
  MULTIPLAN_IMAGE_LOGIN: [
    'https://multiplan-central-lojista.s3.amazonaws.com/login.png',
    'https://multiplan-central-lojista.s3.amazonaws.com/login2.png'
  ],
  MULTIPLAN_IMAGE_SENHA: 'https://multiplan-central-lojista.s3.amazonaws.com/senha.png',
  MULTIPLAN_IMAGE_NEW: '/assets/img/home_nova.png',
  APPID: 'aadf21dd-7908-465d-936c-e51fe10976cc',
  TENANT: 'e27ae7e6-02e0-4721-94fd-7abd7e3fabe6',
  PACKAGE_NAME: 'br.com.multiplan.dev.canallojista',
  HASH_ANDROID: 'ga0RGNYHvNM5d0SLGQfpQWAPGJ8%3D',
  NOVO_BANNER: 'S',
  URL_ENCOMENDA: 'https://encomendasservicedev.z15.web.core.windows.net/'
};
